import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"

export interface StatCardProps {
  title: string
  value: string
  detail: string
  /** Colours the value amber: a number that wants attention. */
  warn?: boolean
  className?: string
}

/** One headline number with a line of context under it. */
export function StatCard({ title, value, detail, warn, className }: StatCardProps) {
  return (
    <Card className={className}>
      <CardHeader className="pb-1">
        <CardDescription>{title}</CardDescription>
        <CardTitle className={`text-3xl ${warn ? "text-amber-600" : ""}`}>{value}</CardTitle>
      </CardHeader>
      <CardContent className="text-sm text-slate-600">{detail}</CardContent>
    </Card>
  )
}
